// ShareAnalytics — client-side helper para tracking leve.
// Não faz nada quando window/localStorage indisponíveis (SSR-safe).
// Envia hit ao backend via GET /api/share/{id}?track=true (já é padrão).

export function trackShareOpened(shareId, apiBaseUrl) {
  try {
    // hit ao endpoint canônico incrementa clicks server-side.
    // Fire-and-forget: se falhar, nada muda.
    void fetch(`${apiBaseUrl}/api/share/${encodeURIComponent(shareId)}?track=true`, {
      method: "GET",
      credentials: "omit",
    });
  } catch {
    /* noop */
  }
}

export function trackShareEvent(eventName, meta = {}) {
  // Placeholder para futuro plug com GA/Segment. Guardamos no localStorage
  // por enquanto (visível no painel do usuário na fase 2).
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    const key = "cm.share.events";
    const arr = JSON.parse(window.localStorage.getItem(key) || "[]");
    arr.push({ event: eventName, at: new Date().toISOString(), meta });
    // cap 100 eventos locais
    while (arr.length > 100) arr.shift();
    window.localStorage.setItem(key, JSON.stringify(arr));
  } catch {
    /* noop */
  }
}

const HIDE_NAME_KEY = "cm.share.hideName";

export function getHideName() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(HIDE_NAME_KEY) === "1";
  } catch {
    return false;
  }
}

export function setHideName(hide) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(HIDE_NAME_KEY, hide ? "1" : "0");
  } catch {
    /* noop */
  }
}
